module.exports = __webpack_public_path__ + "img/landlord-to-tenant.bedcc226.png";